import { Component, HostListener, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { Subscription } from 'rxjs';
import { BroadcastService } from '../../../services/infrastructure/broadcaster.service';
import { ConfigService } from '../../../services/infrastructure/config.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { LoaderService } from '../../../services/infrastructure/loader.service';
import { BlanketOrderService } from '../../../services/blanket-order/blanket-order.service';
import { BlanketAddProductSliderModelService } from '../add-product/blanket-add-product-slider-model.service';
import { UploadAddProductSliderModelService } from './upload-add-product-slider-model.service';
import { ExcelService } from './../../../services/infrastructure/excel.service';

@Component({
  selector: 'app-upload-add-product',
  templateUrl: './upload-add-product.component.html',
  styleUrls: ['./upload-add-product.component.scss']
})
export class UploadAddProductComponent implements OnInit {
  uploadedProductList: any[] = [];
  headerCompany: string;
  productAllDataSource: any;
  expandedElement: any | null; // internal
  isProductNotAdded = true;
  selectedProductList = new Array();
  itemList = new Array();
  displayedColumns: string[] = ['checkbox', 'product', 'detail', 'quantity', 'orderUOM', 'productLine', 'packageSize'];
  filterTypeList = [
    { label: 'Product Name', column: 'productName' },
    { label: 'Package Size', column: 'packageSize' },
    { label: 'Vendor', column: 'vendor' },
    { label: 'Product Line', column: 'productLine' },
    { label: 'Item Number', column: 'itemNumber' },
    { label: 'Active Ingredient', column: 'activeIngredients' },
    { label: 'GTIN', column: 'gtin' }
  ];
  subscription: Subscription = new Subscription();
  selectAll = false;
  errorCount = 0;
  errorCountItemId: Array<number> = [];
  e4_error: string;
  e5_error: string;
  e6_error: string;
  e7_error: string;
  e8_error: string;
  e9_error: string;
  disclaimerMessage: string;
  isShowSelectAllBox = false;

  constructor(
    public excelService: ExcelService,
    public broadcastService: BroadcastService,
    public configService: ConfigService,
    private toastrService: ToastrService,
    private matDialog: MatDialog,
    private loaderService: LoaderService,
    private blanketOrderService: BlanketOrderService,
    private blanketAddProductSliderModelService: BlanketAddProductSliderModelService,
    private uploadAddProductSliderModelService: UploadAddProductSliderModelService,
  ) { }

  ngOnInit() {
    this.disclaimerMessage = 'Prices subject to change without notice. All Products(except inoculants) priced date of shipment & prices refresh daily';
    this.getUploadedProduct();
  }

  // Added Window onresize
  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAddProdTableHeight();
  }

  // Clear Grid data
  clearGridData(filters) {
    this.uploadedProductList.forEach(x => {
      x.showError = false;

      if (x.lineErrors.errors.length > 0 || !x.isValidItem) {
        x.IsProductSelected = false;
        this.errorCount += 1;
      }
      else {
        x.IsProductSelected = true;
      }
    });

    this.productAllDataSource = new MatTableDataSource(this.uploadedProductList);
  }

  getUploadedProduct() {
    this.uploadedProductList = this.uploadAddProductSliderModelService.uploadedProducts;
    if (this.uploadedProductList && this.uploadedProductList.length > 0) {
      const errorMessages = this.uploadedProductList[0].errorMessages;
      if (errorMessages?.length > 0) {
        this.e4_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA04')[0].message;
        this.e5_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA05')[0].message;
        this.e6_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA06')[0].message;
        this.e7_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA07')[0].message;
        this.e8_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA08')[0].message;
        this.e9_error = errorMessages.filter(x => x.code.toUpperCase() == 'EAU_EA09')[0].message;
      }

      this.uploadedProductList.forEach(x => {
        x.showError = false;
        x.errorMessages = errorMessages;
        this.keepRecords(x, false, true);
      });
    }
    else {
      this.toastrService.info('No records found.');
      this.uploadedProductList = [];
    }
    this.productAllDataSource = new MatTableDataSource(this.uploadedProductList);
    this.setAddProdTableHeight();
    this.enableDisableAddProductBtn();
    this.isShowSelectAllBox = this.uploadedProductList.some(x => x.isValidItem);
  }

  // Filter Product GridData based on filter values
  filterProductGridData(filters) {
    if (filters.clearAll == false) {
      this.filterGirdData(filters);
    }
    else {
      filters.clearAll = false;
      const filter: any = {};
      this.setAddProdTableHeight();
      this.filterGirdData(filter);
    }
    this.setAddProdTableHeight();
    this.enableDisableAddProductBtn();
  }

  filterGirdData(filters) {
    let dataList = this.uploadedProductList;
    if (filters.productName) {
      dataList = dataList.filter(f => f.itemDescription.toLowerCase().indexOf(filters.productName.toLowerCase()) > -1);
    }
    if (filters.packageSize) {
      dataList = dataList.filter(f => f.itemDescription.toLowerCase() == filters.packageSize.toLowerCase());
    }
    if (filters.vendor) {
      dataList = dataList.filter(f => f.itemVendorName.toLowerCase().indexOf(filters.vendor.toLowerCase()) > -1);
    }
    if (filters.productLine) {
      dataList = dataList.filter(f => f.productLine.toLowerCase() == filters.productLine.toLowerCase());
    }
    if (filters.itemNumber) {
      dataList = dataList.filter(f => f.itemNumber.toLowerCase() == filters.itemNumber.toLowerCase());
    }
    if (filters.activeIngredients) {
      dataList = dataList.filter(f => f.activeIngredient.toLowerCase().indexOf(filters.activeIngredients.toLowerCase()) > -1);
    }
    if (filters.gtin) {
      dataList = dataList.filter(f => f.gtin.toLowerCase() == filters.gtin.toLowerCase());
    }

    this.productAllDataSource = new MatTableDataSource(dataList);
  }

  // Selected product will add on order
  addSelectedProductToOrder() {
    if (this.selectedProductList.length > 0) {
      let isValid = true;
      this.selectedProductList.forEach(x => {
        this.validateLineItem(x);
        if (x.lineErrors.errors.length > 0) {
          isValid = false;
        }
      });

      if (!isValid) {
        return false;
      }

      this.broadcastService.broadcast(this.configService.DATA_CHANGE, { productCount: this.selectedProductList.length });
      this.toastrService.info('Product Added');
    }
    const data = Object.assign({}, this);
    this.uploadAddProductSliderModelService.setData<UploadAddProductComponent>(data);
    this.uploadAddProductSliderModelService.BlanketClose();
  }

  // Add or remove product from selected list
  selectProduct(element): void {
    element.IsProductSelected = !element.IsProductSelected;
    if (element.lineErrors.errors.length > 0 && element.IsProductSelected && element.isValidItem) {
      this.errorCount = this.errorCount > 0 ? this.errorCount - 1 : 0;
    }
    this.validateLineItem(element);
    this.keepRecords(element, true);
    this.enableDisableAddProductBtn();
  }

  showError(element) {
    if (element.lineErrors.errors.length > 0) {
      element.showError = true;
    }
    else {
      element.showError = false;
    }
    this.keepRecords(element, true);
  }

  // Update selected prodcut list
  keepRecords(product, notSetSelected?, pageLoad: boolean = false) {
    const itemNumber = product.itemNumber;

    if (product.lineErrors.errors.length > 0 || (!product.isValidItem && pageLoad)) {
      product.showError = true;
      product.IsProductSelected = !notSetSelected ? false : product.IsProductSelected;

      if (!this.errorCountItemId.find(x => x === product.itemId)) {
        this.errorCount += 1;
        this.errorCountItemId.push(product.itemId);
      }
    }
    else {
      product.showError = false;
      product.IsProductSelected = !notSetSelected ? true : product.IsProductSelected;

      if (this.errorCountItemId.find(x => x === product.itemId)) {
        this.errorCount -= 1;
        var index = this.errorCountItemId.indexOf(product.itemId);
        if (index !== -1) {
          this.errorCountItemId.splice(index, 1);
        }
      }
    }

    if (product.IsProductSelected) {
      this.itemList.push(itemNumber);
      const item = this.uploadedProductList.filter(i => i.itemNumber == itemNumber && i.isValidItem);
      const duplicateData = this.selectedProductList.find(y => y.itemNumber == product.itemNumber && y.isValidItem);
      if (duplicateData == undefined) {
        this.selectedProductList.push(item[0]);
      }
    }
    else {
      var index = this.itemList.indexOf(itemNumber);    // <-- Not supported in <IE9
      if (index !== -1) {
        this.itemList.splice(index, 1);
      }
      this.selectedProductList = this.selectedProductList.filter(i => i.itemNumber != itemNumber);
    }
    this.enableDisableAddProductBtn();
  }

  // Enable or disable Add product to order btn based on item selection
  enableDisableAddProductBtn() {
    this.isProductNotAdded = this.selectedProductList.length > 0 ? false : true;
  }

  // Show or Hide Product detail
  showProductDetails(item) {
    item.isSelected = !item.isSelected;
  }

  selectAllProduct() {
    this.selectAll = !this.selectAll;
    this.productAllDataSource.data.forEach(x => {
      if (this.selectAll && x.isValidItem) {
        this.validateLineItem(x);
        if (x.lineErrors.errors.length <= 0) {
          x.IsProductSelected = true;
        }
      }
      else {
        x.IsProductSelected = false;
      }
      this.keepRecords(x, true);
    });
    this.enableDisableAddProductBtn();
  }

  // unit change and validation
  orderUnitChange(action: string, productItem: any) {
    const palletConvF = productItem.palletConvF ? +productItem.palletConvF : 1;
    if (action == 'decrease') {
      const decValue = +productItem.quantity - 1;
      if (decValue > 0) {
        const valueBeforeDec = productItem.quantity;
        productItem.quantity = Math.floor(productItem.quantity / palletConvF) * palletConvF;
        if (valueBeforeDec == productItem.quantity) {
          productItem.quantity = (+productItem.quantity > palletConvF ? +productItem.quantity - palletConvF : 0);
        }
      }
      else {
        productItem.quantity = 0;
      }
    }
    else {
      const valueBeforeInc = productItem.quantity;
      productItem.quantity = Math.ceil(productItem.quantity / palletConvF) * palletConvF;
      if (valueBeforeInc == productItem.quantity) {
        productItem.quantity = (+productItem.quantity + palletConvF);
      }
    }

    if (productItem.lineErrors.errors.length > 0 && productItem.IsProductSelected) {
      this.errorCount = this.errorCount > 0 ? this.errorCount - 1 : 0;
    }
    this.validateLineItem(productItem);

    this.keepRecords(productItem);
    this.enableDisableAddProductBtn();
  }

  // Qty change on text change
  quantityTextChange(productItem) {
    if (productItem.lineErrors.errors.length > 0 && productItem.IsProductSelected) {
      this.errorCount = this.errorCount > 0 ? this.errorCount - 1 : 0;
    }

    this.validateLineItem(productItem);
    this.keepRecords(productItem);
    this.enableDisableAddProductBtn();
  }

  // Line item validation
  validateLineItem(item: any) {
    if (item.quantity <= 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
      item.lineErrors.errors.push({ id: 'quantity', error: 'Quantity should be greater than zero' });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'quantity');
    }

    if (item.quantity < item.convertedThresholdUnits) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'thresholdUnits');
      item.lineErrors.errors.push({ id: 'thresholdUnits', error: this.e5_error.replace('{0}', item.convertedThresholdUnits).replace('{1}', item.uom) });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'thresholdUnits');
    }

    if (item.quantity > 0 && item.palletConvF > 0 && item.quantity % item.palletConvF != 0) {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
      item.lineErrors.errors.push({ id: 'conv', error: this.e8_error.replace('{0}', item.palletConvF).replace('{1}', item.uom) });
    }
    else {
      item.lineErrors.errors = item.lineErrors.errors.filter(y => y.id != 'conv');
    }

    return item;
  }

  public exportProducts() {
    const exportData = [];
    this.loaderService.setLoaderStatus(true);
    if (this.uploadedProductList && this.uploadedProductList.length > 0) {
      const filteredList = this.uploadedProductList.filter(x => x.displayMessage == null);
      filteredList.forEach(x => {
        exportData.push({
          'Product Code': x.itemNumber,
          'Product': x.itemDescription,
          'Quantity': x.quantity,
          'Order UOM': x.uom,
          'Product Line': x.productLine,
          'Package Size': x.packageSize,
          'Error': x.lineErrors.errors.length > 0 ? 'Yes' : 'No',
          'Selected': x.IsProductSelected == true ? 'Yes' : 'No',
        });
      });
      this.excelService.exportAsExcelFile(exportData, 'BlanketProductsReport');
    }
    this.loaderService.setLoaderStatus(false);
  }

  // set Add product table height
  setAddProdTableHeight() {
    const tableHeight = window.innerHeight - $('h3').outerHeight() - $('.form-sec ').outerHeight() - $('.add-order-sec').outerHeight() - 65;
    $('.prodTableContainer').css('max-height', tableHeight + 'px');
  }
}
